module.exports = __webpack_public_path__ + "img/paul_74.9c6a7e17.jpg";